/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { getEntityAttribute } from "./get-entity-attribute";

const EntityAttribute = (props) => {
    
    const reference = props?.reference;
    const type = props?.type;
    const name = props?.name;
    const value = props?.value;
    const position = props?.position;
    const EntityView = getEntityAttribute(type);

    return (
        <div key={`${name}_${position}`} className="entity-attribute-editor">
            <EntityView
                type={type}
                name={name}
                value={value}
                reference={reference}
            />
        </div>
    );
};

export { EntityAttribute };
